import { Injectable } from '@angular/core';

export interface FormDataStandard {
  [key: string]: any; // form keys and values
  translations?: {
    [key:string]: // language keys
      {[key: string]: any} // form keys and values
  };
}

@Injectable({
  providedIn: 'root'
})
export class FormCachingService {

  key_prefix: string = 'form_draft_'; // 'form_draft_new_snapshot'
  expiry_prefix: string = 'expiry_'; // 'expiry_new_snapshot'

  constructor() {

    this.clearAllData(true);
  }

  clearData(){
    this.clearAllData(false);
  }

  clearAllData(onlyExpired:boolean){
    const now = Date.now();
    for (const unprefixed_key of this.draftKeys()) {
      let expiry : number = +localStorage.getItem(this.expiry_prefix+unprefixed_key);
      if(!onlyExpired || (onlyExpired && now > expiry)){
        this.clearDataItem(unprefixed_key);
      }
    }
  }

  // Collected before any is removed: removing while walking localStorage by index skips entries
  private draftKeys(): string[] {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(this.key_prefix)) {
        keys.push(key.substring(this.key_prefix.length));
      }
    }
    return keys;
  }

  cacheFormData(data: FormDataStandard, key : string, expiry : number = null): void {
    this.cacheDataItem(data, key, expiry);
  }
  cacheDataItem(data: any, key : string, expiry : number = null): void {
    if(!data || !key ){return;}
    expiry = expiry ?? Date.now() + (24 * 60 * 60 * 1000); // by default 24 hours in the future
    localStorage.setItem(this.key_prefix+key, JSON.stringify(data));
    localStorage.setItem(this.expiry_prefix+key, expiry.toString());
  }
  getDataItem(key : string): any {
    const savedData = localStorage.getItem(this.key_prefix+key);
    return savedData && key ? JSON.parse(savedData) : null;
  }
  clearDataItem(key : string): void {
    localStorage.removeItem(this.key_prefix+key);
    localStorage.removeItem(this.expiry_prefix+key);
  }



}
